import NiceModal from '@ebay/nice-modal-react';
import { TrashIcon } from '@heroicons/react/24/outline';
import type { CellContext } from '@tanstack/react-table';
import { twMerge } from 'tailwind-merge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/UI/Tooltip';
import { DeleteConfirmationModal } from '@/features/ChangeOrder/Summary/DeleteConfirmationModal';
import type { ColMeta } from '@/features/ChangeOrder/Summary/Table/types';

export function ActionsCell({ column, cell }: CellContext<any, any>) {
  const columnMeta = column.columnDef.meta as ColMeta | undefined;
  const id = cell.row.original.id;

  const isDisabled = ['APPROVED', 'REJECTED'].includes(cell.row.original.status);

  const deleteMutation = columnMeta?.useDeleteMutation?.();

  return (
    <div className='edit-cell-container'>
      <div className='w-24 flex gap-4'>
        <Tooltip>
          <TooltipTrigger>
            <button
              disabled={isDisabled}
              className={twMerge([
                'rounded-full p-2 text-neutralColor-normal hover:text-tertiaryColor-normal hover:bg-neutralColor-lighter transition duration-300 ease-in-out',
                'disabled:opacity-50 disabled:cursor-not-allowed',
              ])}
            >
              <TrashIcon
                className='h-5 w-5'
                onClick={(e) => {
                  e.stopPropagation();
                  NiceModal.show(DeleteConfirmationModal, {
                    title: columnMeta?.deleteModalTitle,
                    id: id,
                    deleteMutation,
                  });
                }}
              />
            </button>
          </TooltipTrigger>
          {isDisabled && <TooltipContent>You can't archive Approved or Rejected change order</TooltipContent>}
        </Tooltip>
      </div>
    </div>
  );
}
